export const openRoles = [
  {
    id: "preschool-teacher",
    title: "Preschool Teacher",
    department: "Academics",
    type: "Full-Time",
    experience: "3+ Years",
    qualification: "N.T.T. / E.C.C.E. / B.Ed. Certified",
    desc: "We are looking for a warm, creative, and passionate teacher who loves working with children and can implement play-based curriculum.",
    status: "Active"
  },
  {
    id: "assistant-teacher",
    title: "Assistant Teacher",
    department: "Academics",
    type: "Full-Time",
    experience: "1+ Years",
    qualification: "Graduate with good communication skills",
    desc: "Support classroom activities, help children with routines, and collaborate with lead teachers to create a nurturing environment.",
    status: "Active"
  },
  {
    id: "activity-teacher",
    title: "Activity Teacher (Art & Craft / STEAM)",
    department: "Co-Curricular",
    type: "Part-Time",
    experience: "2+ Years",
    qualification: "Fine Arts Graduate / STEAM trainer certificate",
    desc: "Conduct creative art, craft, building block, or simple science experiment workshops for preschool groups.",
    status: "Active"
  },
  {
    id: "reception-admin",
    title: "Reception and Administration",
    department: "Admin & Helpdesk",
    type: "Full-Time",
    experience: "2+ Years",
    qualification: "Graduate with proficiency in English and computers",
    desc: "Manage front desk inquiries, greet parents, handle admissions documentation, and maintain database records.",
    status: "Active"
  }
];
